import React from "react";
import {Modal} from "react-bootstrap";
import "./log-detail-modal.css"

const LogDetailModal = ({show, log, handleClose, onViewFullHistory}) => {
    if (!log) return null;

    return (
        <Modal show={show} onHide={handleClose} size="sm" centered scrollable className="log-detail-modal">
            <Modal.Header className="position-relative text-center justify-content-center border-0">
                <div className="position-absolute end-0 top-50 translate-middle-y me-3">
                    <svg
                        type="button"
                        className="btn-close recent-activities-modal-close"
                        aria-label="Close"
                        onClick={handleClose}
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="27"
                        viewBox="0 0 26 27"
                        fill="none"
                    >
                        <path
                            d="M13 1.5C19.2984 1.5 24.5 6.81872 24.5 13.5C24.5 20.1813 19.2984 25.5 13 25.5C6.70158 25.5 1.5 20.1813 1.5 13.5C1.5 6.81872 6.70158 1.5 13 1.5Z"
                            stroke="#9DACBD"
                            strokeWidth="3"
                        />
                        <path d="M8 8.5L17.5 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M17.5 8.5L8 18" stroke="#9DACBD" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex gap-3 py-2 border-bottom">
                    <span className="log-detail-modal-labels">
                        Usuario:
                    </span>
                    <span className="log-detail-modal-labels-light">
                        {log.elevva_admin_email}
                    </span>
                </div>
                <div className="d-flex gap-3 py-2 border-bottom">
                    <span className="log-detail-modal-labels">
                        Acción:
                    </span>
                    <span className="log-detail-modal-labels-light">
                        {log.log_type_label}
                    </span>
                </div>
                <div className="d-flex gap-3 py-2 border-bottom">
                    <span className="log-detail-modal-labels">
                        Fecha:
                    </span>
                    <span className="log-detail-modal-labels-light">
                        {log.date}
                    </span>
                </div>
                <div className="d-flex gap-3 py-2 border-bottom">
                    <span className="log-detail-modal-labels">
                        Hora:
                    </span>
                    <span className="log-detail-modal-labels-light">
                        {log.time}
                    </span>
                </div>
                {log?.customer_fullname && (
                    <div className="d-flex gap-3 py-2 border-bottom">
                    <span className="log-detail-modal-labels">
                        Atleta:
                    </span>
                        <span className="log-detail-modal-labels-light">
                        {log?.customer_fullname}
                    </span>
                    </div>
                )}
                <div className="d-flex flex-column gap-1 py-2 border-bottom">
                    <span className="log-detail-modal-labels">
                        Cambio aplicado:
                    </span>
                    <span className="log-detail-modal-labels-light">
                        {log.log_description_admin}
                    </span>
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0 justify-content-center">
                <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => {
                        onViewFullHistory({email: log.elevva_admin_email})
                        handleClose();
                    }}
                >
                    Ver historial completo de este usuario
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default LogDetailModal;
